import { getStore } from '../store/Store';

/** Selector function which returns list of notification Id's which are unseen */
export function getUnseenItemIds() {
    return [...getStore().items.values()]
        .filter(item => item.isSeen === false)
        .map(item => item.id);
}
